import type { DocRow, SearchRow } from "@/modules/docs/types";

/** A row flattened to the field names its section declares. */
export type Projection = Record<string, unknown>;

/** A `DocRow` flattened for `RECENT_FIELDS`. */
export function projectDocRow(row: DocRow): Projection {
  return {
    title: row.page.title,
    folderPath: row.folder?.path ?? "",
    updatedAt: row.page.updatedAt,
    authorName: row.authorName,
    message: row.content?.revision.message ?? "",
  };
}

/** A `SearchRow` flattened for `SEARCH_FIELDS`. */
export function projectSearchRow(row: SearchRow): Projection {
  return {
    ...projectDocRow(row),
    context: row.snippet,
  };
}
